import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import { isEmpty } from "lodash";

import { premiumsApiUpsellProvider } from "../../lib/api/providers";
import {
  GET_PREMIUM_LIST,
  SET_PREMIUM_LIST,
  GET_LIMITS_BONUSES,
  SET_LIMITS_BONUSES_LIST,
  GET_REGULAR_BONUSES,
  SET_REGULAR_BONUSES_LIST
} from "../types";
import { BONUS_TYPE_ID } from "../../configs/constants";

const getBonusesListApi = (endpoint, token, params) => {
  const filters = isEmpty(params) ? { sort: { start_date: -1 } } : { ...params, sort: { start_date: -1 } };

  return endpoint
    .post(`/`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => console.log(e));
};

const getRegularBonusesApi = (token, filters = {}) => {
  return premiumsApiUpsellProvider
    .post(
      `/`,
      { ...filters, type_id: BONUS_TYPE_ID.REGULAR },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getLimitsBonusesApi = (token, filters = {}) => {
  return premiumsApiUpsellProvider
    .post(`/limits`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getAuthState = state => state.auth || {};
const getClientState = state => state.currentClient || {};

export function* getBonusesList(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(getBonusesListApi, premiumsApiUpsellProvider, stateAuth.token, action.payload);

    if (values) {
      yield put({
        type: SET_PREMIUM_LIST,
        payload: values
      });
    }
  } catch (e) {
    console.log(e.message);
  }
}

export function* getLimitsBonuses() {
  try {
    const stateAuth = yield select(getAuthState);
    const stateClient = yield select(getClientState);
    const client_id = stateClient.id;
    const token = stateAuth.token;
    const limits = yield call(getLimitsBonusesApi, token, { client_id });

    if (limits) {
      yield put({
        type: SET_LIMITS_BONUSES_LIST,
        payload: limits
      });
    }
  } catch (e) {
    console.log(e.message, e);
  }
}

export function* getRegularBonuses() {
  try {
    const stateAuth = yield select(getAuthState);
    const stateClient = yield select(getClientState);
    const client_id = stateClient.id;
    const token = stateAuth.token;
    const regularBonuses = yield call(getRegularBonusesApi, token, { client_id });

    if (regularBonuses) {
      yield put({
        type: SET_REGULAR_BONUSES_LIST,
        payload: regularBonuses
      });
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* watchFetchPremiumList() {
  yield takeLatest(GET_PREMIUM_LIST, getBonusesList);
}

function* watchFetchLimitBonuses() {
  yield takeLatest(GET_LIMITS_BONUSES, getLimitsBonuses);
}
function* watchFetchRegularBonuses() {
  yield takeLatest(GET_REGULAR_BONUSES, getRegularBonuses);
}

export default function* root() {
  yield all([fork(watchFetchPremiumList), fork(watchFetchLimitBonuses), fork(watchFetchRegularBonuses)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/premiumSagas.js